export const PER_PAGE = 15
export const PER_PAGE_OPTIONS = [15, 50, 100]



// WEBPACK FOOTER //
// ./src/config/constans.js